module.exports = __webpack_public_path__ + "media/images/normas-ba_icon_16-d6070325acedf9e2c5bf63531ffa3d1c.png";